import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ProductRetouchingModal } from './index';

type OpenParams = Omit<React.ComponentProps<typeof ProductRetouchingModal>, 'show'>;

export class ProductRetouchingSDK {
    private static container: HTMLDivElement | null = null;

    static open(params: OpenParams) {
        if (this.container) return; // 防止重复打开

        this.container = document.createElement('div');
        document.body.appendChild(this.container);

        const Wrapper: React.FC = () => {
            const [visible, setVisible] = useState(true);

            useEffect(() => {
                return () => {
                    ProductRetouchingSDK.destroy();
                };
            }, []);

            const handleClose = () => {
                setVisible(false);
                params.onClose();
            };

            return (
                <ProductRetouchingModal
                    {...params}
                    show={visible}
                    onClose={handleClose}
                    onModalClose={() => {
                        ProductRetouchingSDK.destroy();
                    }}
                />
            );
        };

        ReactDOM.render(<Wrapper />, this.container);
    }

    private static destroy() {
        if (this.container) {
            ReactDOM.unmountComponentAtNode(this.container);
            document.body.removeChild(this.container);
            this.container = null;
        }
    }
}
